import { AbstractControl, ValidatorFn } from '@angular/forms';
import { GlobalConstants } from '@app-core';

export class PhoneValidator {
    static phone(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const phonePattern = GlobalConstants.VALIDATION_REGEX.phonePattern;

            // Allow null or undefined values to be valid
            if (control.value === '' || control.value === null || control.value === undefined) {
                return null;
            }

            const valid = phonePattern.test(control.value);
            return valid ? null : { invalidPhone: { value: control.value } };
        };
    }
}
